import { render, staticRenderFns } from "./goldBuyCartManage.vue?vue&type=template&id=15e27601&scoped=true"
import script from "./goldBuyCartManage.vue?vue&type=script&lang=js"
export * from "./goldBuyCartManage.vue?vue&type=script&lang=js"
import style0 from "./goldBuyCartManage.vue?vue&type=style&index=0&id=15e27601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e27601",
  null
  
)

export default component.exports